import { useNavigationLoading } from "@/hooks/useNavigationLoading";
import { useEffect } from "react";
import { announceToScreenReader } from "@/utils/accessibility";

/**
 * NavigationLoader - Top loading bar that appears during route navigation
 * Matches the design system with gradient colors
 * Provides immediate visual feedback when navigating between pages
 */
export default function NavigationLoader() {
  const isNavigating = useNavigationLoading();

  useEffect(() => {
    if (isNavigating) {
      announceToScreenReader("Loading new page", "polite");
    } else {
      announceToScreenReader("Page loaded", "polite");
    }
  }, [isNavigating]);

  if (!isNavigating) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[200] h-1 overflow-hidden pointer-events-none"
      role="status"
      aria-label="Loading page"
      aria-live="polite"
      aria-busy="true"
    >
      {/* Background track */}
      <div className="absolute inset-0 bg-[rgba(255,255,255,0.1)]" />

      {/* Animated gradient bar that continuously progresses */}
      <div
        className="h-full absolute top-0 left-0"
        style={{
          width: "30%",
          background:
            "radial-gradient(circle at top right, #FFE76E 0%, #E926FF 50%, #232EFF 100%)",
          animation: "loadingProgress 2s linear infinite",
          boxShadow: "0 0 10px rgba(233, 38, 255, 0.5)",
        }}
      />
    </div>
  );
}
